import React from 'react';

import styled from 'styled-components';

import theme from 'constants/theme';

import { Typography13 } from 'uiToolkit/Typography';

const Container = styled.div`
  display: flex;
  padding-left: ${(props) => props.$paddingLeft ?? '36px'};
`;

const LineMakerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const VerticalLine = styled.div`
  height: 100%;
  border-left: 1px solid ${(props) => props.theme.palette.primary.main};
`;

const LShapeDiv = styled.div`
  flex: 0 0 auto;
  height: 32px;
  width: 32px;
  border-left: 1px solid ${(props) => props.theme.palette.primary.main};
  border-bottom: 1px solid ${(props) => props.theme.palette.primary.main};
`;

const LineMaker = ({ isLast = false }) => (
  <LineMakerContainer>
    <LShapeDiv />
    {isLast ? null : <VerticalLine />}
  </LineMakerContainer>
);

const SubCompetencyRow = ({ name, isLast = false, paddingLeft = '36px' }) => (
  <Container $paddingLeft={paddingLeft}>
    <LineMaker isLast={isLast} />
    <Typography13 weight={600} color={theme.palette.grey.dark} topGutter={2.5} bottomGutter={2.5} leftGutter={1.5}>
      {name}
    </Typography13>
  </Container>
);

const SubCompetencyList = ({ subCompetencies, paddingLeft = '36px' }) => (
  <>
    {Array.isArray(subCompetencies)
      ? subCompetencies.map(({ name, subCompetencyId }, index) => (
          <SubCompetencyRow
            name={name}
            key={subCompetencyId}
            isLast={index === subCompetencies.length - 1}
            paddingLeft={paddingLeft}
          />
        ))
      : null}
  </>
);

export default SubCompetencyList;
